<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>付费数据(仅统计最近两周环比)</span>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      border
    >
      <!--      <el-table-column-->
      <!--        prop="week"-->
      <!--        label="日期"-->
      <!--        width="200px"-->
      <!--      >-->
      <!--        <template scope="r">-->
      <!--          {{ r.row.start_date }} - {{ r.row.end_date }}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column
        prop="week"
        label="周"
        width="200px"
        align="center"
      >
        <template scope="r">
          <span v-if="r.row.week !== '环比'">
            {{ r.row.week }} ( {{ r.row.start_date }} - {{ r.row.end_date }})
          </span>
          <span v-else>{{ r.row.week }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="reg_pay_countr"
        label="注册首日付费人数"
        align="center"
      />
      <el-table-column
        prop="reg_pay_price"
        label="注册首日付费金额"
        align="center"
      />
      <el-table-column
        prop="pay_count"
        label="总付费人数"
        align="center"
      />
      <el-table-column
        prop="pay_price"
        label="总付费金额"
        align="center"
      />
      <el-table-column
        prop="pay_rate"
        label="付费率日均"
        align="center"
        :formatter="numFormatter"
      />
      <el-table-column
        prop="arppu"
        label="周付费ARPPU"
        :formatter="numFormatter"
        align="center"
      />
      <el-table-column
        prop="arpu"
        label="周付费ARPU"
        :formatter="numFormatter"
        align="center"
      />
      <!--      <el-table-column-->
      <!--        prop="order_count"-->
      <!--        label="总订单数"-->
      <!--      />-->
      <el-table-column
        prop="success_order"
        label="成功订单数"
        align="center"
      />
      <!--      <el-table-column-->
      <!--        prop="order_rate"-->
      <!--        label="订单成功率"-->
      <!--      />-->
      <el-table-column
        prop="ad_price"
        label="广告收入"
        align="center"
      />
    </el-table>
  </el-card>
</template>

<script>
import { isNumeric } from 'echarts/lib/util/number'

export default {
  name: 'WeekPay',
  data() {
    return {
      tableData: []
    }
  },
  created() {
  },
  methods: {
    init(data) {
      this.tableData = data
      if (data.length > 1) {
        const first = data[0]
        const second = data[1]
        const row = {
          week: '环比',
          reg_pay_countr: this.rate(first.reg_pay_countr, second.reg_pay_countr),
          reg_pay_price: this.rate(first.reg_pay_price, second.reg_pay_price),
          pay_count: this.rate(first.pay_count, second.pay_count),
          pay_price: this.rate(first.pay_price, second.pay_price),
          pay_rate: this.rate(first.pay_rate, second.pay_rate),
          arppu: this.rate(first.arppu, second.arppu),
          arpu: this.rate(first.arpu, second.arpu),
          order_count: this.rate(first.order_count, second.order_count),
          success_order: this.rate(first.success_order, second.success_order),
          order_rate: this.rate(first.order_rate, second.order_rate),
          ad_price: this.rate(first.ad_price, second.ad_price)
        }
        this.tableData.push(row)
      }
    },
    numFormatter(col, row, val) {
      if (col.week === '环比') {
        return val
      }
      return val + '%'
    },
    rate(start, end) {
      let rate = ((end - start) / start * 100).toFixed(2)
      if (!isNumeric(rate)) {
        rate = 0
      }
      if (rate > 0) {
        return <span style='color:#F56C6C'>{rate}%</span>
      } else {
        return <span style='color:#67C23A'>{rate}%</span>
      }
    }
  }
}
</script>

<style scoped>

</style>
